export enum BillingLocales {
  Suomi = 0,
  Englanti = 1,
}
